import { ISkillGroupDetailParam } from "../_shared/types";

namespace SkillGroupDetailURLParameter {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _ = 0;
  export namespace Param {
    export type Payload = ISkillGroupDetailParam;
  }
}
export default SkillGroupDetailURLParameter;
